













import Vue from "vue";

export default Vue.extend({
    props: {
        flags: {
            type: Array,
            required: true
        }
    },
    data: function() {
        return {
            isFlagTrimmed: true
        };
    },
    mounted: function() {
        // Medium
        /* istanbul ignore next */
        this.$responsive.registerMediaQuery("from-medium", () => {
            this.isFlagTrimmed = false;
        });

        this.$responsive.registerMediaQuery("to-medium", () => {
            this.isFlagTrimmed = true;
        });
    }
});
